/* src/app/invoice/management/invoice-management/invoice-management.component.scss */
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .p-datatable .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 4.2em;
}
body#themeTag :host ::ng-deep div.invoice-cycle,
body#themeTag :host ::ng-deep div.invoice-schedule {
  height: calc(50% - 65px);
  overflow: auto;
}
/*# sourceMappingURL=invoice-management.component.css.map */
